/*
 *
 * File JS per la Homepage
 *
 */

import './general.scss';

// IMPORT COMPONENTI
//--------------------------------------------------------------------//
import animateIn from 'animations/animate-in/animate-in';

import initHeader from 'components/header/header';
import heroSlider from 'imComponents/hero-slider/hero-slider';
import heroImage from 'imComponents/hero-image/hero-image';
import breadcrumbs from 'components/breadcrumbs/breadcrumbs';
import button from 'components/buttons/buttons';
import cmsContent from 'components/cms-content/cms-content';
import footer from 'components/footer/footer';
import contactForm from 'components/contact-form/contact-form';
import textOnBg from 'imComponents/text-on-bg/text-on-bg';
import accordion from 'imComponents/accordion/accordion';
import cardNews from 'components/cards/card-news';
import sliderNews from 'components/slider-news/slider-news';
import carouselGallery from 'imComponents/carousel-gallery/carousel-gallery';
import cardTextImg from 'components/cards/card-text-img';
import sliderTextImg from 'components/slider-text-img/slider-text-img';
import listBlock from 'components/list-block/list-block';
import boxImage from 'components/box-image/box-image';
import textIframe from 'components/text-iframe/text-iframe';
import titleBox from 'components/title-box/title-box';
import modal from 'imComponents/modal/modal';
import textImgFix from 'imComponents/text-img-fix/text-img-fix';
import boxModules from 'components/box-modules/box-modules';
import textLink from 'components/text-link/text-link';
import cardTextLink from 'components/cards/card-text-link';
import blockInfographic from 'components/block-infographic/block-infographic';
import partners from 'components/partners/partners';
import boxInfo from 'components/box-info/box-info';
import sliderColTextImg from 'components/slider-col-text-img/slider-col-text-img';
import cardColTextImg from 'components/cards/card-col-text-img';
import blockParallax from 'components/block-parallax/block-parallax';
import listIconText from 'components/list-icon-text/list-icon-text';
import blockVideo from 'components/block-video/block-video';
import cropAnimation from 'animations/crop-animation/crop-animation';
import videoAutoplayOnEnter from 'animations/video-autoplay-onenter/video-autoplay-onenter';

//--------------------------------------------------------------------//

// INIT COMPONENTI
//--------------------------------------------------------------------//
function initAllComponents() {
    if (!document.querySelector('body.wp-admin')) {
        initHeader();
        heroSlider();
    }
    animateIn();
    accordion();
    carouselGallery();
    sliderNews();
    sliderTextImg();
    modal();
    blockInfographic();
    sliderColTextImg();
    blockVideo();
    cropAnimation();
    videoAutoplayOnEnter();
}
if (document.querySelector('body.wp-admin')) {
    (function ($) {
        var initBlock = function ($block) {
            initAllComponents();
        };
        if (window.acf) {
            window.acf.addAction('render_block_preview', initBlock);
        }
    })(jQuery);
}
initAllComponents();
//--------------------------------------------------------------------//
